<template>
  <div class="author-detail">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/author' }">大咖</el-breadcrumb-item>
      <el-breadcrumb-item>{{ authorInfo.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <template v-if="authorInfo">
      <div class="detail-wrapper">
        <div class="detail-left">
          <author-info-panel :authorInfo="authorInfo"></author-info-panel>
          <!-- 个人介绍 -->
          <personal-description-panel
            :description="authorInfo.remark"
          ></personal-description-panel>
        </div>
        <div class="detail-products">
          <ul class="tabs">
            <li
              class="tab"
              v-for="(item, index) in tabs"
              :key="item.type"
              :class="{ 'tab--active': activeTab === index }"
              @click="changeTab(index)"
            >
              {{ item.name }}
            </li>
          </ul>
          <dian-jin-list
            v-if="activeTab == 0"
            :list="dianjinList"
            :showAuthor="showAuthor"
            :end="pageEndForDianJin"
            @loadMore="getDianJinList"
          >
          </dian-jin-list>
          <jinNang-list
            v-else-if="activeTab == 1"
            class="jinnang-list"
            :sortType="0"
            :list="jinNangList"
            :end="pageEndForJinNang"
            :showAuthor="showAuthor"
            @loadMore="getJinNangList"
          ></jinNang-list>
          <course-list
            v-else-if="activeTab == 2"
            :list="courseList"
            :showButton="showButton"
            :end="pageEndForCourse"
            @loadMore="getCourseList"
          ></course-list>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getAuthorDetail } from '@/api/author'
import { getJinNangList } from '@/api/jinNangList'
import { getDianjinList } from '@/api/dianjin'
import { getCourseList } from '@/api/course'
import DianJinList from '@/components/DianJinList/DianJinList'
import CourseList from '@/components/CourseList/CourseList'
import AuthorInfoPanel from '@/components/AuthorInfoPanel/AuthorInfoPanel'
import JinNangList from '@/components/JinNangList/JinNangList'
import PersonalDescriptionPanel from '@/components/PersonalDescriptionPanel/PersonalDescriptionPanel'
export default {
  name: 'AuthorDetail',
  components: {
    AuthorInfoPanel,
    PersonalDescriptionPanel,
    JinNangList,
    CourseList,
    DianJinList
  },
  data() {
    return {
      tabs: [
        { name: '点金', type: 2 },
        { name: '锦囊', type: 3 },
        { name: '课程', type: 4 }
      ],
      activeTab: 0,
      showAuthor: false,
      showButton: true,
      authorInfo: {},
      viewStateForDianJin: '',
      viewStateForCourse: '',
      viewStateForJinNang: '',
      dianjinList: [],
      courseList: [],
      jinNangList: [],
      pageEndForDianJin: true,
      pageEndForCourse: true,
      pageEndForJinNang: true
    }
  },

  computed: {
    authorId() {
      return this.$route.params.id
    }
  },
  created() {
    this.getAuthorDetail()
    this.getDianJinList()
    this.getCourseList()
    this.getJinNangList()
  },
  mounted() {
    this.getDefaultTab()
  },
  methods: {
    buyCourse() {},
    changeTab(index) {
      this.activeTab = index
    },
    getDefaultTab() {
      let index = 0
      if (this.$route.query.activeTab) {
        const tab = this.$route.query.activeTab
        index = parseInt(tab)
      }
      this.changeTab(index)
    },
    async getAuthorDetail() {
      this.authorInfo = await getAuthorDetail(this.authorId)
    },
    async getDianJinList() {
      const data = await getDianjinList(
        {
          authorId: this.authorId,
          direction: this.viewStateForDianJin ? 2 : 0
        },
        this.viewStateForDianJin
      )
      if (data) {
        if (data.result.code === 0) {
          this.viewStateForDianJin = data.result.viewState
          this.pageEndForDianJin = data.detail.end
          if (data.detail.list.length === 0) {
            this.pageEndForDianJin = true
          }
          if (data.detail.flush) {
            this.dianjinList = data.detail.list
          } else {
            this.dianjinList = this.dianjinList.concat(data.detail.list)
          }
        }
      }
    },
    async getCourseList() {
      const data = await getCourseList(
        {
          authorId: this.authorId,
          direction: this.viewStateForCourse ? 2 : 0
        },
        this.viewStateForCourse
      )
      if (data) {
        if (data.result.code === 0) {
          this.pageEndForCourse = data.result.viewState
          this.pageEndForCourse = data.detail.end
          if (data.detail.list.length === 0) {
            this.pageEndForCourse = true
          }
          if (data.detail.flush) {
            this.courseList = data.detail.list
          } else {
            this.courseList = this.courseList.concat(data.detail.list)
          }
        }
      }
    },
    async getJinNangList() {
      const data = await getJinNangList(
        {
          authorId: this.authorId,
          direction: this.viewStateForJinNang ? 2 : 0
        },
        this.viewStateForJinNang
      )
      if (data) {
        if (data.result.code === 0) {
          this.pageEndForJinNang = data.result.viewState
          this.pageEndForJinNang = data.detail.end
          if (data.detail.list.length === 0) {
            this.pageEndForJinNang = true
          }
          if (data.detail.flush) {
            this.jinNangList = data.detail.list
          } else {
            this.jinNangList = this.jinNangList.concat(data.detail.list)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.author-detail {
  padding-top: 30px;
}
ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.tabs {
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  color: #262626;
  text-align: center;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  margin-bottom: 30px;

  .tab {
    width: 98px;
    cursor: pointer;
  }

  .tab--active {
    position: relative;
    color: #046bcc;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 34px;
      height: 4px;
      background-color: #046bcc;
    }
  }
}
.detail-wrapper {
  display: flex;
  margin-top: 30px;
  padding-bottom: 30px;
  flex: auto;
}
.detail-left {
  margin-right: 40px;
}

.detail-products {
  display: flex;
  flex-direction: column;
  flex: auto;
}
.dianjin-list {
  display: flex;
  flex-direction: column;
}
.dianjin {
  height: 160px;
}
.dianjin-inline {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.dianjin-pic {
  width: 160px;
  height: 120px;
  background: no-repeat center;
  background-size: cover;
  cursor: pointer;
}
.dianjin-right {
  margin-left: 20px;
  flex: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  align-content: space-between;
}
.dianjin-title {
  font-size: 20px;
  line-height: 40px;
  color: #262626;
  transition: color 0.3s;
  cursor: pointer;
  text-decoration: none;
}

.dianjin-date {
  position: absolute;
  bottom: 13px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #858585;
}
.dianjin-comment {
  display: flex;
  position: absolute;
  bottom: 13px;
  right: 5px;
  text-decoration: none;
}

.more {
  width: 828px;
  height: 40px;
  margin: 30px auto;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}

.comment-icon {
  width: 24px;
  height: 20px;
  background: url('~@/assets/images/author/comment_icon.png') no-repeat center;
  background-size: cover;
  margin-right: 5px;
}

.dianjin-play-icon {
  width: 80px;
  height: 80px;
  position: absolute;
  left: 45px;
  top: 37px;
  background: url('~@/assets/images/dianjin/dianjin-list-icon.png') no-repeat
    center;
}
.comment-number {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #858585;
}

.course {
  display: flex;
  align-items: center;
  position: relative;
  height: 160px;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
  transition: background-color 0.3s linear;

  &:hover {
    background-color: #fafafa;
  }

  .cover-img {
    width: 160px;
    height: 120px;
    background: no-repeat center;
    background-size: cover;
  }

  .title {
    font-size: 20px;
    line-height: 40px;
    color: #262626;
    transition: color 0.3s;
    text-decoration: none;

    &:hover {
      color: #046bcc;
    }
  }

  .count {
    font-size: 16px;
    line-height: 40px;
    letter-spacing: 1px;
    color: #858585;
  }

  .course-right {
    padding-left: 20px;
  }

  .price {
    font-size: 20px;
    line-height: 40px;
    color: #e64c2e;
  }

  .original-price {
    position: relative;
    font-size: 14px;
    color: #858585;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      height: 1px;
      background-color: #858585;
    }
  }
  .button-buy {
    width: 90px;
    position: absolute;
    line-height: 40px;
    margin-left: 20px;
    right: 10px;
    background-color: #e64c2e;
    border-radius: 2px;
    font-size: 16px;
    color: #ffffff;
    padding: 0;
    border: none;
  }
}

.jin-nang {
  display: flex;
  align-items: center;
  position: relative;
  height: 160px;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
  transition: background-color 0.3s linear;

  &:hover {
    background-color: #fafafa;
  }
}
</style>
